import type { IconProps } from '@playbooks/ui/components/icon';
import { Icon } from '@playbooks/ui/components/icon';
import { cn } from '@playbooks/ui/lib/utils';

type IconWellSize = '2xs' | 'xs' | 'sm' | 'default' | 'lg';
type IconWellVariant = 'muted' | 'accent';

type IconWellProps = Omit<IconProps, 'size' | 'type'> & {
	type?: Exclude<IconProps['type'], `wrapped-${string}`>;
	size?: IconWellSize;
	variant?: IconWellVariant;
};

const sizeClasses: Record<IconWellSize, string> = {
	'2xs': 'size-6 text-xs',
	xs: 'size-8 text-sm',
	sm: 'size-9 text-sm',
	default: 'size-10 text-base',
	lg: 'size-16 text-2xl',
};

const variantClasses: Record<IconWellVariant, string> = {
	muted: 'bg-surface-hover text-foreground-body',
	accent: 'bg-surface-hover text-foreground',
};

const IconWell = ({ type = 'fad', size = 'default', variant = 'muted', className = '', ...props }: IconWellProps) => {
	// Theme
	const rootClassName = cn(
		'flex-middle-inline shrink-0 rounded-panel',
		sizeClasses[size],
		variantClasses[variant],
		className,
	);

	// Render
	return (
		<span data-slot='icon-well' className={rootClassName}>
			<Icon type={type} {...props} />
		</span>
	);
};

export { IconWell };
export type { IconWellProps, IconWellSize, IconWellVariant };
